// This file is for IATA stuff likely shared between integrations
export namespace IATA {
  export enum HandlingCode {
    /**
     * ACTIVE IN-USE BY INTEAFRATIONS
     * These are verified and actively in use by integrations
     */

    // Stacking/Handling/Weight/Known
    /** @description NON-STACKABLE  */
    NST = 'NST',
    /** @description HEAVY CARGO, (OVER 150KG PER PIECE)  */
    HEA = 'HEA',
    /** @description CARGO PRE-SCREENED  */
    SPX = 'SPX',
    /** @description UNKNOWN SHIPPER  */
    UNK = 'UNK',

    // Batteries
    /** @description EXCEPTED LITHIUM ION BATTERIES  */
    ELI = 'ELI',
    /** @description EXCEPTED LITHIUM METAL BATTERIES  */
    ELM = 'ELM',

    // Cooling
    /** @description COOLING: CONTROL ROOM TEMPERATURE +15°C TO +25°C (FIFTEEN_TO_TWENTY_FIVE_CELSIUS)  */
    CRT = 'CRT',
    /** @description COOLING: COLD ROOM TEMPERATURE +2°C TO +8°C (TWO_TO_EIGHT_CELSIUS)  */
    COL = 'COL',
    /** @description COOLING: EXTENDED ROOM TEMPERATURE +2°C TO +25°C (TWO_TO_TWENTY_FIVE_CELSIUS)  */
    ERT = 'ERT',
    /** @description COOLING: DRY ICE  */
    ICE = 'ICE',

    // Cargo Types
    /** @description DANGEROUS GOODS / HAZARDOUS MATERIAL  */
    HAZ = 'HAZ',
    /** @description PERISHABLE GOODS  */
    PER = 'PER',
    /** @description PHARMA  */
    PIL = 'PIL',
    /** @description VALUABLE CARGO */
    VAL = 'VAL',

    // Q-Plus
    /* PRIORITY SMALL PACKAGE */
    XPS = 'XPS',
    // Q-Prime
    VIC = 'VIC',

    /**
     * NOT IN-USE BY INTEGRATIONS
     * These are not verified to be accurate
     */
    /* ACTIVE TEMPERATURE CONTROLLED SYSTEM */
    ACT = 'ACT',
    /* UNCONTROLLED AMBIENT CONDITIONS */
    AMB = 'AMB',
    /* AIRCRAFT ON GROUND */
    AOG = 'AOG',
    /* GOODS ATTACHED TO AWB */
    ATT = 'ATT',
    /* LIVE ANIMALS */
    AVI = 'AVI',
    /* AQUATIC LIFE FORMS / INSECTS */
    AXI = 'AXI',
    /* LIVE BEES */
    BEE = 'BEE',
    /* OUTSIZED */
    BIG = 'BIG',
    /* BUMPED CARGO */
    BMP = 'BMP',
    /* BLOCK SPACE AGREEMENT PRIORITY 1 */
    BSA = 'BSA',
    /* BULK UNITIZATION PROGRAM SHIPPER CNEE HANDLED UNIT */
    BUP = 'BUP',
    /* CARGO ACFT ONLY */
    CAO = 'CAO',
    /* CANNABIS IN FLIGHT */
    CIF = 'CIF',
    /* CARGO NETWORK SUPPORT */
    CNS = 'CNS',
    /* COMPANY MAIL */
    COM = 'COM',
    /* COVID-19 VACCINE SHIPMENT */
    COV = 'COV',
    /* CORD BLOOD SHIPMENT */
    CRD = 'CRD',
    /* DOCUMENTS ATTACHED TO SHIPMENT */
    DAS = 'DAS',
    /* DIPLOMATIC MAIL */
    DIP = 'DIP',
    /* DOCUMENTS */
    DOC = 'DOC',
    /* DOCUMENTS DELIVERED */
    DOD = 'DOD',
    /* E-FREIGHT PARTIAL DOCUMENT POUCH */
    EAP = 'EAP',
    /* FOODSTUFFS */
    EAT = 'EAT',
    /* E-FREIGHT NO DOCUMENT POUCH */
    EAW = 'EAW',
    /* ELECTRONICALLY CONCLUDED CARGO CONTRACT */
    ECC = 'ECC',
    /* ECOMMERCE */
    ECM = 'ECM',
    /* EAWB PRINT */
    ECP = 'ECP',
    /* ECOMMERCE HEAVY */
    EHV = 'EHV',
    /* ELECTRONIC MONITORING DEVICES ON/IN CARGO/ULD */
    EMD = 'EMD',
    /* AIR CANADA EMPLOYEE DISCOUNT ON NAF */
    EMP = 'EMP',
    /* AIR CANADA EMPLOYEE ON PRIORITY FREIGHT */
    EMR = 'EMR',
    /* EMERGENCY MEDICAL SHIPMENTS */
    EMS = 'EMS',
    /* ECOMMERCE OVERSIZE */
    EOV = 'EOV',
    /* ECOMMERCE SIGNATURE REQUIRED */
    ESG = 'ESG',
    /* ECOMMERCE EXTRA HEAVY */
    EXV = 'EXV',
    /* FDX - FEDEX STANDARD NEXT DAY */
    FDX = 'FDX',
    /* FES - FEDEX PRIORITY SOLUTION */
    FES = 'FES',
    /* UNDEVELOPED UNEXPOSED FILM */
    FIL = 'FIL',
    /* FROZEN GOODS SUBJECT TO INSPECTION */
    FRI = 'FRI',
    /* FROZEN GOODS */
    FRO = 'FRO',
    /* HANGING GARMENTS */
    GOG = 'GOG',
    /* ECOMMERCE HEAVY SHIPMENT */
    HAV = 'HAV',
    /* HEAVY LOOSE BULK LOADED SHIPMENT */
    HEB = 'HEB',
    /* HATCHING EGGS */
    HEG = 'HEG',
    /* HUMAN REMAINS IN COFFIN */
    HUM = 'HUM',
    /* CAT/DOG */
    KNL = 'KNL',
    /* LIVE HUMAN ORGANS/BLOOD */
    LHO = 'LHO',
    /* LICENSE REQUIRED */
    LIC = 'LIC',
    /* MAGNETIZED MATERIAL */
    MAG = 'MAG',
    /* MAIL */
    MAL = 'MAL',
    /* MAIN DECK CARGO */
    MDC = 'MDC',
    /* MILITARY PERSONNEL - DISCOUNT */
    MIL = 'MIL',
    /* MUNITIONS OF WAR */
    MUW = 'MUW',
    /* NOT SECURED CARGO */
    NSC = 'NSC',
    /* NEWSPAPERS AND MAGAZINES */
    NWP = 'NWP',
    /* OVERHEAD BIN ORIGIN */
    OBO = 'OBO',
    /* OVERHEAD BIN TRANSIT STATION */
    OBT = 'OBT',
    /* OBNOXIOUS CARGO */
    OBX = 'OBX',
    /* OVERHEAD BIN CARGO */
    OHB = 'OHB',
    /* OVERHANG ITEM */
    OHG = 'OHG',
    /* ECOMMERCE OVERSIZED PACKAGE */
    OVS = 'OVS',
    /* HUNTING TROPHIES AND ART OF ENDANGERED SPECIES */
    PEA = 'PEA',
    /* ANIMAL PRODUCTS FOR NON-HUMAN CONSUMPTION */
    PEB = 'PEB',
    /* FLOWERS */
    PEF = 'PEF',
    /* MEAT */
    PEM = 'PEM',
    /* FRUITS AND VEGTABLES */
    PEP = 'PEP',
    /* FISH SEAFOOD */
    PES = 'PES',
    /* GOODS SUBJECT TO PHYTOSANITARY INSPECTIONS */
    PHY = 'PHY',
    /* PIERCING CARGO */
    PIE = 'PIE',
    /* HORSES */
    PLH = 'PLH',
    /* MAIN DECK PALLET */
    PMD = 'PMD',
    /* LIVE BABY POULTRY LESS THAN 72 HRS OLD */
    POU = 'POU',
    /* AC PHARMACAIR SIMPLE */
    PPS = 'PPS',
    /* PRIORITY SHIPMENT */
    PRI = 'PRI',
    /* PWG - WING PALLET */
    PWG = 'PWG',
    /* QUICK RAMP TRANSFER */
    QRT = 'QRT',
    /* CRYOGENIC LIQUIDS */
    RCL = 'RCL',
    /* CORROSIVE */
    RCM = 'RCM',
    /* EXPLOSIVES 1.3C */
    RCX = 'RCX',
    /* BIOLOGICAL SUBSTANCE, CATEGORY B (UN3373) */
    RDS = 'RDS',
    /* EXCEPTED QUANTITIES OF DANGEROUS GOODS */
    REQ = 'REQ',
    /* NORMALLY FORBIDDEN EXPLOSIVES 1.1,1.2,1.3,1.4F,1.5 */
    REX = 'REX',
    /* FLAMMABLE COMPRESSED GAS */
    RFG = 'RFG',
    /* FLAMMABLE LIQUID */
    RFL = 'RFL',
    /* FLAMMABLE SOLID */
    RFS = 'RFS',
    /* DANGEROUS WHEN WET */
    RFW = 'RFW',
    /* RECOVERY FREIGHT PRIORITY 1 */
    RFZ = 'RFZ',
    /* EXPLOSIVES 1.3G */
    RGX = 'RGX',
    /* INFECTIOUS SUBSTANCE */
    RIS = 'RIS',
    /* RESTRICTED LITHIUM ION BATTERIES */
    RLI = 'RLI',
    /* RESTRICTED LITHIUM METAL BATTERIES */
    RLM = 'RLM',
    /* MISCELLANEOUS DANGEROUS GOODS */
    RMD = 'RMD',
    /* NON FLLAMMABLE NON TOXIC GAS */
    RNG = 'RNG',
    /* ORGANIC PEROXIDE */
    ROP = 'ROP',
    /* OXIDIZER */
    ROX = 'ROX',
    /* TOXIC SUBSTANCE */
    RPB = 'RPB',
    /* TOXIC GAS */
    RPG = 'RPG',
    /* EXCEPTED PACKAGE OF RADIOACTIVE MATERIAL */
    RRE = 'RRE',
    /* RADIOACTIVE MATERIAL */
    RRR = 'RRR',
    /* RADIOACTIVE MATERIAL, CATEGORY I-WHITE */
    RRW = 'RRW',
    /* RADIOACTIVE MATERIAL, CATEGORIES II AND III YELLOW */
    RRY = 'RRY',
    /* POLYMERIC BEADS */
    RSB = 'RSB',
    /* SPONTANEOUSLY COMBUSTIBLE */
    RSC = 'RSC',
    /* SHIPMENT TO BE RETURNED */
    RTN = 'RTN',
    /* EXPLOSIVES 1.4B */
    RXB = 'RXB',
    /* EXPLOSIVES 1.4C */
    RXC = 'RXC',
    /* EXPLOSIVES 1.4D */
    RXD = 'RXD',
    /* EXPLOSIVES 1.4E */
    RXE = 'RXE',
    /* EXPLOSIVES 1.4G */
    RXG = 'RXG',
    /* EXPLOSIVES 1.4S */
    RXS = 'RXS',
    /* SHIPPER BUILT UNIT */
    SBU = 'SBU',
    /* NON-SECURE CARGO FOR DOMESTIC FREIGHTER ONLY */
    SCO = 'SCO',
    /* SFX */
    SFX = 'SFX',
    /* SAVE HUMAN LIFE */
    SHL = 'SHL',
    /* SECURE IN ACCORDANCE WITH HIGH RISK REQUIREMENTS */
    SHR = 'SHR',
    /* ECOMMERCE SIGNATURE REQUIRED */
    SIG = 'SIG',
    /* SKIDDED CARGO */
    SKD = 'SKD',
    /* BRACHYCEPHALIC "SNUB NOSE" DOGS AND CATS */
    SNB = 'SNB',
    /* LABORATORY ANIMALS */
    SPF = 'SPF',
    /* SRA RATING FROM SRALOG ISSUED BY SALE OFFICES */
    SRA = 'SRA',
    /* 130% SURCHARGE - MANUAL INPUT BY HDQ ONLY */
    SRP = 'SRP',
    /* SECONDARY SCREENING */
    SSC = 'SSC',
    /* SURFACE TRANSPORTATION */
    SUR = 'SUR',
    /* SPORTING WEAPONS */
    SWP = 'SWP',
    /* TYVEK COVERS */
    TVK = 'TVK',
    /* UPPER DECK CARGO */
    UDC = 'UDC',
    /* UPPER DECK CARGO ORIGIN */
    UDO = 'UDO',
    /* UPPER DECK TRANSIT STATION */
    UDT = 'UDT',
    /* CONTAINERIZED CARGO */
    ULD = 'ULD',
    /* VOLUME */
    VOL = 'VOL',
    /* CREMATED REMAINS & VULNERABLE CARGO */
    VUN = 'VUN',
    /* WET MATERIAL NOT PACKAGED IN WATERTIGHT CONTAINERS */
    WET = 'WET',
  }
}
